import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconMountain$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconMountain extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '8c93b0a8eb76e3a9054e55e3e822b71c02ebe681', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'fc459f49eb849da7ef290cfe7858bc46565f2991', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '3c4c4f764afa5c0b5c9f5db1d60c8ff152bf1bae', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M7.93 5.517a1.31 1.31 0 0 1-1.219.803 1.3 1.3 0 0 1-1.3-1.299 1.31 1.31 0 1 1 2.52.496M9.3 13.1l3.865-5.497 5.292 7.527h-7.73l1.106 1.573-5.23-7.437a.524.524 0 0 0-.857 0l-4.649 6.61a.524.524 0 0 0 .429.827h18.95a.524.524 0 0 0 .429-.826L13.593 5.48a.524.524 0 0 0-.858 0l-4.397 6.254zm-3.126-1.71-2.63 3.74h5.26z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-mountain", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-mountain"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-mountain":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconMountain$1);
            }
            break;
    } });
}

const CosmosIconMountain = CosmosIconMountain$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconMountain, defineCustomElement };
